export function roundRupees(n) {
  return Math.round(Number(n) || 0);
}
